import { render, staticRenderFns } from "./BaseFormMessage.vue?vue&type=template&id=16101a32&scoped=true&"
import script from "./BaseFormMessage.vue?vue&type=script&lang=js&"
export * from "./BaseFormMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16101a32",
  null
  
)

export default component.exports